import * as Rx from 'rxjs/Rx'
import { Action, Store } from 'redux'
import { ActionsObservable, combineEpics } from 'redux-observable'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { Login } from '../../actions'

// Sign up an account
export const signUp = (
  action$: ActionsObservable<Action>,
  _store: Store<State>,
  { logger, apiClient }: Dependencies
) =>
  action$.filter(Login.signUp.started.match).switchMap(({ payload }) =>
    apiClient
      .createUser(payload)
      .map(user =>
        Login.signUp.done({
          params: payload,
          result: user
        })
      )
      .catch((error: Rx.AjaxError) => {
        logger.error('Fail to sign up, error=', error)
        return Rx.Observable.of(
          Login.signUp.failed({
            params: payload,
            error: error.xhr.response.extra_info
          })
        )
      })
  )

export default combineEpics<Epic>(signUp)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/operations/signUp.ts